interface ForceWindowRenderAction
{
    type: 'FORCE_WINDOW_RENDER';
    payload: {
        stateLocation: string;
    };
}

export const forceWindowRender = (stateLocation: string): ForceWindowRenderAction  => {
    return {
        type: 'FORCE_WINDOW_RENDER',
        payload: {
            stateLocation: stateLocation,
        },
    };
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/skinner/src/actions/actions.ts